import {
  ButtonHTMLAttributes,
  forwardRef,
  ForwardRefRenderFunction,
} from 'react';
import { clsx } from '@team/clsx';
import css from './style.module.css';

type Props = ButtonHTMLAttributes<HTMLButtonElement>;

const Layout: ForwardRefRenderFunction<HTMLButtonElement, Props> = (
  { className, ...props },
  ref
) => <button {...props} className={clsx(className, css.root)} ref={ref} />;

export const LayoutWithRef = forwardRef(Layout);
